import React, { useState } from "react";
import ItemImagePicker from "@components/item/ItemImagePicker";
import useScrollReset from "@hooks/ScrollHook";
import { AttributeInputs } from "@components/AttributesInputs";
import { CustomDropdown } from "@components/dropdown/CustomDropdown";
import { useAccount } from "@contexts/AccountContext";
import { useSelectedChain } from "@app/examples/ChainSelector";
import { useApi } from "@hooks/ApiHook";
import { CollectionDropdownItem } from "@components/dropdown/CollectionDropdownItem";
import ItemJsonPicker from "@components/item/ItemJsonPicker";
import useAlert from "@hooks/AlertHook";
import { useBaaanggg } from "@hooks/BaaangggHook";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "@hooks/QueryParamsHook";
import { Coin, MsgSend, TxInfo } from "@terra-money/terra.js";
import { useTxModal } from "@hooks/TxModalHook";

function CreateItemPage() {
    useScrollReset()

    const txModal = useTxModal();
    const { collectionId } = useQueryParams();
    const navigate = useNavigate()
    const alert = useAlert()
    const baaangggg = useBaaanggg()
    const { address } = useAccount()
    const { selectedChain } = useSelectedChain()
    const { data: collections } = useApi(api => api.collection.simple({ chainId: selectedChain?.id, ownerAddress: address }), [address, selectedChain])

    const [attributes, setAttributes] = useState<{ type: string, value: string }[]>([])
    const [name, setName] = useState("")
    const [supply, setSupply] = useState("1")
    const [description, setDescription] = useState("")
    const [image, setImage] = useState<File>()
    const [collection, setCollection] = useState<string | undefined>(collectionId ?? undefined)

    const onJsonPick = (json: { name: string, description?: string, attributes?: { trait_type: string, value: string }[] }) => {
        setName(json.name)
        if (json.description) setDescription(json.description)
        if (json.attributes) setAttributes(json.attributes.map(e => ({ type: e.trait_type, value: e.value })))
    }

    const onSubmit = async () => {
        try {
            let supplyNumber = Number(supply)
            if (!image) throw new Error("Image is required")
            if (!collection) throw new Error("Collection not selected")
            if (isNaN(supplyNumber) || supplyNumber < 1) throw new Error("Supply must be a number greater than 0")

            alert.loading("Creating Item")
            const item = await baaangggg.item.store({
                supply: supplyNumber,
                collectionId: collection,
                image: image,
                name: name,
                description: description,
                traits: attributes.map(e => ({ traitType: e.type, value: e.value }))
            })
            alert.success("Item created successfully")
            navigate(`/item/${item.id}`)
        } catch (e) {
            if (e instanceof Error) alert.failed(`Cannot create item, reason: ${e.message}`)
            else console.log(e)
        }
    }

    return <>
        <main>
            <section className="relative py-24">
                <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
                    <img src="img/gradient_light.jpg"
                        alt="gradient"
                        className="h-full w-full" />
                </picture>
                <div className="container">
                    <h1 className="py-16 text-center font-display text-4xl font-medium text-jacarta-700 dark:text-jacarta-500">Create NFT</h1>

                    <div className="mx-auto max-w-[48.125rem]">
                        <ItemImagePicker onChange={value => setImage(value)} />

                        <ItemJsonPicker onChange={object => onJsonPick(object as any)} />

                        <div className="mb-6">
                            <label htmlFor="item-name"
                                className="mb-2 block font-display text-jacarta-700 dark:text-white">Name</label>
                            <input
                                value={name}
                                onChange={({ target }) => setName(target.value)}
                                type="text"
                                id="item-name"
                                className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                placeholder="Item name"
                                required />
                        </div>

                        <div className="mb-6">
                            <label htmlFor="item-description"
                                className="mb-2 block font-display text-jacarta-700 dark:text-white">Description</label>
                            <p className="mb-3 text-2xs dark:text-gray-400">
                                The description will be included on the item's detail page underneath its image
                            </p>
                            <textarea
                                value={description}
                                onChange={({ target }) => setDescription(target.value)}
                                id="item-description"
                                className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                rows={4}
                                required
                                placeholder="Provide a detailed description of your item."></textarea>
                        </div>

                        <div className="mb-6">
                            <label className="mb-2 block font-display text-jacarta-700 dark:text-white">Traits</label>
                            <AttributeInputs attributes={attributes} onChange={attributes => setAttributes(attributes)} />
                        </div>

                        <div className="mb-6">
                            <label htmlFor="item-supply"
                                className="mb-2 block font-display text-jacarta-700 dark:text-white">Supply</label>
                            <input
                                value={supply}
                                onChange={({ target }) => setSupply(target.value)}
                                type="number"
                                id="item-supply"
                                className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                placeholder="Item supply"
                                required />
                        </div>

                        {
                            collections && <div className="mb-6">
                                <label className="mb-2 block font-display text-jacarta-700 dark:text-white">Collection</label>
                                <CustomDropdown
                                    value={collection}
                                    onSelected={item => setCollection(item?.id)}
                                    builder={(collection, isSelected) => <CollectionDropdownItem
                                        isSelected={isSelected}
                                        collection={collection} />}
                                    format={item => item.name}
                                    items={collections} />
                            </div>
                        }

                        <button
                            onClick={onSubmit}
                            className="rounded-full bg-jacarta-500 py-3 px-8 text-center font-semibold text-white transition-all hover:bg-jacarta-600">
                            Create
                        </button>
                    </div>
                </div>
            </section>
        </main>
    </>
}

export default CreateItemPage;